import { ProductsFilterValues } from "./types";

export const defaultProductFilterValues: ProductsFilterValues = {
  supplierIds: [],
  categoryIds: [],
  departmentIds: [],
  isMainProduct: false,
  notRetailerProduct: false,
};

export const productFilterValuesToApiInput = (
  filterValues: ProductsFilterValues
) => {
  let v = {};

  if (filterValues.departmentIds?.length) {
    v = {
      ...v,
      departmentId: {
        in: filterValues.departmentIds,
      },
    };
  }

  if (filterValues.categoryIds?.length) {
    v = {
      ...v,
      categoryId: {
        in: filterValues.categoryIds,
      },
    };
  }

  if (filterValues.supplierIds?.length) {
    v = {
      ...v,
      supplierId: {
        in: filterValues.supplierIds,
      },
    };
  }

  if (filterValues.isMainProduct) {
    v = {
      ...v,
      internal: {
        eq: false,
      },
    };
  }

  if (filterValues.notRetailerProduct) {
    v = {
      ...v,
      stockCode: {
        isNull: true,
      },
    };
  }

  return v;
};
